import React, { useCallback } from 'react';
import { format, getDay, isFuture } from 'date-fns';

import { Button, Modal } from '../../index';
import ContactForm from '../../forms/ContactForm';
import InfoSessionsForm from '../../forms/InfoSessionsForm';
import { useSiteQuery } from '../../../hooks';
import { useFormModal } from '../../../hooks/useFormModal';

import DateIcon from '../../../images/icons/date.svg';
import PinIcon from '../../../images/icons/pin.svg';
import TimeIcon from '../../../images/icons/time.svg';

import query from './infoSessions.graphql';

import styles from './styles.module.scss';

interface Props {
  className?: string;
}

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const InfoSessionsButton = ({ className }: Props) => {
  const [{ data }] = useSiteQuery<InfoSessionsQuery>({ query });
  const { isOpen: infoSessionModal, openModal: openInfoModal, closeModal: closeInfoModal } = useFormModal(['infoSessionsForm']);
  const { isOpen: enquireModal, openModal: openEnquireModal, closeModal: closeEnquireModal } = useFormModal(['enquireForm', 'contactForm']);

  const emailClick = useCallback(() => {
    closeInfoModal();
    openEnquireModal();
  }, [closeInfoModal, openEnquireModal]);

  if (data?.entry?.infoSessionsDetails?.length) {
    const rows: InfoSessionsDetailsTableRow[] = [];
    const dates: string[] = [];
    data.entry.infoSessionsDetails.map((r) => {
      if (r && isFuture(new Date(r.date))) {
        rows.push(r);
        dates.push(format(new Date(r.date), 'do MMMM yyyy'));
      }
    });
    const info: InfoSessionsDetailsTableRow = rows?.[0];

    if (info) {
      const date = new Date(info.date);
      return (
        <div className={styles.event}>
          <p>Upcoming session date</p>
          {info?.time && (
            <div className={styles.infoTime}>
              <TimeIcon />
              {info?.time}
            </div>
          )}
          {info?.date && (
            <div className={styles.info}>
              <DateIcon />
              {`${days[getDay(date)]} ${format(date, 'do MMMM yyyy')}`}
            </div>
          )}
          {info?.location && (
            <div className={styles.info}>
              <PinIcon />
              {info?.location}
            </div>
          )}
          <Button onClick={openInfoModal} className={className} type="solidOrange" large>
            Register for an event
          </Button>
          <Modal
            isOpen={infoSessionModal}
            onRequestClose={closeInfoModal}
            title="Information Sessions"
          >
            <InfoSessionsForm dates={dates} emailClick={emailClick} />
          </Modal>
          <Modal isOpen={enquireModal} onRequestClose={closeEnquireModal} title="Information Sessions">
            <ContactForm title="Information Sessions" />
          </Modal>
        </div>
      );
    }
  }

  return null;
};

export default InfoSessionsButton;
